<template>
  <div>
    <div id="dContentdetalis">
      <div id="cNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
          :to="{path:'/Social/forum'}">青博名家讲堂</router-link>
        <!--&nbsp;&nbsp;>>&nbsp;&nbsp;
				<span style="clear: both;">{{ tableData.title }}</span>-->
      </div>
      <div>
        <div id="detials">
          <div><span>活动时间：</span><span>{{ tableData.hstime }}</span>&nbsp;-&nbsp;<span>{{ tableData.hetime }}</span></div>
          <div><span>报名时间：</span><span>{{ tableData.bstime }}</span>&nbsp;-&nbsp;<span>{{ tableData.betime }}</span></div>
          <div><span>主讲人：</span>{{ tableData.jname }}</div>
          <div><span>简介：</span>{{tableData.introduction}}</div>
          <div><span>活动地点：</span>{{ tableData.address }}</div>
        </div>
        <div style="border-bottom: 1px solid #DEDEDE;margin-top: 25px;"></div>
        <div v-if="tableData.videotype=='102'" >
          <el-row :gutter="15" class="d-video">
            <el-col style="width: 70%;">
                <video id="myVideo" class="video-js" tabindex="2" mediatype="video" loop="loop" controls="controls" preload="auto" :src="tableData.video"
                  style="width: 100%;"></video>
            </el-col>
          </el-row>
        </div>
        <div id="contents" v-html="tableData.contents"></div>
      </div>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
    <div id="mdContentdetalis">
      <div id="mcNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
          :to="{path:'/Social/forum'}">青博名家讲堂</router-link>
      </div>
      <div>
        <div id="mdetials">
          <div><span>活动时间：</span><span>{{ mtableData.hstime }}</span>&nbsp;-&nbsp;<span>{{ mtableData.hetime }}</span></div>
          <div><span>报名时间：</span><span>{{ mtableData.bstime }}</span>&nbsp;-&nbsp;<span>{{ mtableData.betime }}</span></div>
          <div><span>主讲人：</span>{{ mtableData.jname }}</div>
          <div><span>简介：</span>{{mtableData.introduction}}</div>
          <div><span>活动地点：</span>{{ mtableData.address }}</div>
        </div>
        <div style="border-bottom: 1px solid #DEDEDE;margin-top: 25px;"></div>
        <div v-if="tableData.videotype=='102'" >
          <el-row :gutter="15" class="d-video">
            <el-col style="width: 70%;">
                <video id="myVideo" class="video-js" tabindex="2" mediatype="video" loop="loop" controls="controls" preload="auto" :src="tableData.video"
                  style="width: 100%;"></video>
            </el-col>
          </el-row>
        </div>
        <div style="margin-top: 20px;" v-html="mtableData.contents"></div>
      </div>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  import moment from 'moment'
  export default {
    data() {
      return {
        clientHeight: '',
        tableData: [],
        mtableData: [],
        infoid: '',
        loading: false,
        title: '',
        config: {
          url: location.href.split("&t=")[0],
          source: "",
          title: decodeURIComponent(this.$route.query.t),
          description: "",
          image: "",
          weiboKey: "",
          wechatQrcodeTitle: "微信扫一扫：分享",
          wechatQrcodeHelper: "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
          wechatQrcodeSize: 100,
          sites: ["weibo", "qq", "wechat"],
          mobileSites: [],
          disabled: [],
          initialized: !1
        }
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("dContentdetalis").style.display = "none";
        this.mhandleSearch();
      } else {
        document.getElementById("mdContentdetalis").style.display = "none";
        document.getElementById("dContentdetalis").style.display = "block";
        this.handleSearch();
      }
      this.handleSearch();
      $("body,html").animate({
        scrollTop: 0
      }, 1);
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSearch() {
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;

        this.loading = true;
        this.infoid = this.$route.query.id;
        let url = this.HOST + '/api/v1/social/getOneLecture/' + this.infoid + '';
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.title = cData.data.title;
          if (cData && cData.data) {
            that.tableData = cData.data;
            let hstime = parseInt(that.tableData.htime);
            let hetime = parseInt(that.tableData.hendtime);
            //报名
            let bstime = parseInt(that.tableData.btime);
            let betime = parseInt(that.tableData.bendtime);
            that.tableData.hstime = moment(hstime).format("YYYY-MM-DD HH:mm");
            that.tableData.hetime = moment(hetime).format("YYYY-MM-DD HH:mm");
            that.tableData.bstime = moment(bstime).format("YYYY-MM-DD HH:mm");
            that.tableData.betime = moment(betime).format("YYYY-MM-DD HH:mm");
          }
        }).catch(function(error) {
          console.log(err);
        })
      },
      mhandleSearch() {
        this.msearch();
      },
      // 查询列表
      msearch: function() {
        let that = this;
        this.loading = true;
        this.infoid = this.$route.query.id;
        this.infoid = this.$route.query.id;
        let url = this.HOST + '/api/v1/social/getOneLecture/' + this.infoid + '';
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.title = cData.data.title;
          if (cData && cData.data) {
            that.mtableData = cData.data;
            let hstime = parseInt(that.mtableData.htime);
            let hetime = parseInt(that.mtableData.hendtime);
            //报名
            let bstime = parseInt(that.mtableData.btime);
            let betime = parseInt(that.mtableData.bendtime);
            that.mtableData.hstime = moment(hstime).format("YYYY-MM-DD HH:mm");
            that.mtableData.hetime = moment(hetime).format("YYYY-MM-DD HH:mm");
            that.mtableData.bstime = moment(bstime).format("YYYY-MM-DD HH:mm");
            that.mtableData.betime = moment(betime).format("YYYY-MM-DD HH:mm");
          }
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #dContentdetalis {
    display: none;
    width: 70%;
    margin-right: 15%;
    margin-left: 15%;
    height: 100%;
  }

  #dContentdetalis>#cNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #cNav>span:nth-child(1),
  #cNav>span:nth-child(2) {
    cursor: pointer;
  }

  #cNav>span:nth-child(1):hover,
  #cNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  #dContentdetalis>div:nth-child(2)>div:nth-child(3) {
    text-align: left;
    line-height: 30px;
  }

  #detials {
    text-align: left;
  }

  #detials>div {
    line-height: 30px;
  }

  #contents {
    margin-top: 20px;
  }

  /*mobile*/
  #mdContentdetalis {
    margin: auto 20px;
    height: 100%;
  }

  #mdContentdetalis>#mcNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #mcNav>span:nth-child(1),
  #mcNav>span:nth-child(2) {
    cursor: pointer;
  }

  #mcNav>span:nth-child(1):hover,
  #mcNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  #mdContentdetalis>div:nth-child(2)>div:nth-child(3) {
    text-align: left;
    line-height: 30px;
  }

  #mdetials {
    text-align: left;
  }

  #mdetials>div {
    line-height: 30px;
  }
  .d-video {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 30px 0;
  }
  
  .nav-video {
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Social/forumDetials.vue